import React from 'react'
import ProfileNavbar from '../../../../components/Profile-navbar/profile-navbar'

import pic from '../../../../images/pic.png'
import ellipse from '../../../../images/ellipse-group.svg'
import { ProfileInfoPercentage, ProfileInfo } from '../../../../data'

import './jobseeker.css'
import { Container, Card,Col, Row, Form, Button} from 'react-bootstrap';

const JobSeekerProfile = () => {
  return (
    <div>
      <ProfileNavbar/>
      <Container fluid className='py-5 px-lg-5 px-md-2'>
        <div className='mt-5 mx-0 mx-md-5 pt-5'>
          <div className='image-holder'>
          <img src={pic} alt='' className='profile-image'/>
          </div>
          <Card className='justify-content-center align-items-center text-center section-center mt-5 border-0 ' style={{background: '#D9D9D9',position:'relative', paddingTop:'130px'}}>
            <h3 className='mb-3'>Alex John</h3>
            <p>Experience: Less than 1 year</p>
            <p>Availability:  More than 3 months</p>
            <p>Location: Ibadan, Oyo State</p>
          </Card>
        </div>
        <Row className='d-none d-md-flex mt-5 px-1'>
          <Col xl={8} md={7}  >
          {
                ProfileInfo.map((profile) => {
                  const {id,label,placeholder} = profile;
                  return (
                    <Card className='mb-3 p-4 border-0 profile-input-card' style={{borderRadius: 'none'}}>
                      <Form.Label className='profile-label'>{label}</Form.Label>
                      <Form.Control type="text" className="profile-input-field mt-4 p-2 " placeholder={placeholder} />

                      <a href='#' className='d-flex justify-content-end save-link mt-3'>Update</a>


                    </Card>
                  )
                })
              }
          
          </Col>
          <Col xl={4} md={5}>
          <Card className='p-0 m-0 border-0'>
          <Card.Header className='d-flex align-items-center p-3 gap-5 gap-md-3 gap-lg-5 section-col-1'>
            <img src={ellipse}/>
            <p>Complete your profile</p>
          </Card.Header>
          <Card.Text className='section-col-2 pt-3'>
            {ProfileInfoPercentage.map((pip) => {
              const {id,icon,text, percentage} = pip;
              return(
                <div className='d-flex justify-content-between align-items-center px-3'>
                    <div className='d-flex align-items-center justify-content-center text-center gap-3 mb-3 section-row'>
                      <img src={icon} alt='icon'/>
                      <p>{text}</p>
                    </div>
                    <p className='section-p'>{percentage}</p>
                </div>
              )
            })}
          </Card.Text>
          </Card>
          <Card className='section-col-3 align-items-center justify-content-center text-center py-5 px-2 mt-5'>
          
            <h1>Unlock new features by completing your profile</h1>
         
          </Card>
          
          </Col>
        </Row>
        <Row className='d-flex d-md-none mt-5 px-1'>
        <Col xl={4} md={5} className=''>
          <Card className='p-0 m-0 border-0 mx-sm-5'>
          <Card.Header className='d-flex align-items-center p-3 gap-5 gap-md-3 gap-lg-5 section-col-1'>
            <img src={ellipse}/>
            <p>Complete your profile</p>
          </Card.Header>
          <Card.Text className='section-col-2 pt-3'>
            {ProfileInfoPercentage.map((pip) => {
              const {id,icon,text, percentage} = pip;
              return(
                <div className='d-flex justify-content-between align-items-center px-3'>
                    <div className='d-flex align-items-center justify-content-center text-center gap-3 mb-3 section-row'>
                      <img src={icon} alt='icon'/>
                      <p>{text}</p>
                    </div>
                    <p className='section-p'>{percentage}</p>
                </div>
              )
            })}
          </Card.Text>
          </Card>
          <Card className='section-col-3 align-items-center justify-content-center text-center py-5 px-2 mt-5 mb-5 mx-sm-5'>
          
            <h1>Unlock new features by completing your profile</h1>
         
          </Card>
          
          </Col>
          <Col xl={8} md={7}  >
          {
                ProfileInfo.map((profile) => {
                  const {id,label,placeholder} = profile;
                  return (
                    <Card className='mb-3 p-4 border-0 profile-input-card' style={{borderRadius: 'none'}}>
                      <Form.Label className='profile-label'>{label}</Form.Label>
                      <Form.Control type="text" className="profile-input-field mt-4 p-2 " placeholder={placeholder} />
                      
                      <a href='#' className='save-link mt-3'>Update</a>


                    </Card>
                  )
                })
              }
          
          </Col>
          
        </Row>
      </Container>
      
     
    </div>
  )
}

export default JobSeekerProfile
